import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import App from './demo/App';
import $ from "jquery";

import './FeedImage.css';


const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.paper,
  },
  gridList: {
    width: 500,
    height: 450,
  },
}));

const FeedImage = (props) => { 
    let {media_details,dynamic_class,setActiveImage,currentFeed,currentActiveImage,carousalFeed} = props;
    const seeMore   = (media_details.length) - 3;
    const totalMedia= (media_details.length);
    /* if(media_details.length > 3){
      media_details = media_details.slice(0, 3);
    } */
    let imageIndex = 0;
    const classes   = useStyles();
    const innerHght = $("#post_img").innerHeight();
    const innerWdth = `${$("#post_img").innerWidth()}px !important`;
    let iteration = 0;
    const setImageindex = (index) => {
      setActiveImage(index,currentFeed);
    }
   
    return (
     <div>
        <App 
          currentActiveImage = {currentActiveImage} 
          media_details      = {media_details} 
          carousalFeed       = {carousalFeed}
          post_my_reaction   = {props.post_my_reaction}
          post_total_reaction= {props.post_total_reaction}
          post_total_comment = {props.post_total_comment}
          post_total_share   = {props.post_total_share}
        />
      </div>
    );
};
export default FeedImage;